var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMnAdmGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 60.2,
    viewBox: "0 0 70 60.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_mn_adm_grey",
    transform: "translate(-0.1 -4.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9957",
    "data-name": "Path 9957",
    d: "M66.2,65.1H3.9A3.8,3.8,0,0,1,.1,61.3V8.7A3.8,3.8,0,0,1,3.9,4.9H66.3a3.8,3.8,0,0,1,3.8,3.8V61.4A3.937,3.937,0,0,1,66.2,65.1Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9964",
    "data-name": "Path 9964",
    d: "M59.024,58.488H3.487A3.384,3.384,0,0,1,.1,55.105V8.283A3.384,3.384,0,0,1,3.487,4.9H59.113A3.384,3.384,0,0,1,62.5,8.283V55.194A3.507,3.507,0,0,1,59.024,58.488Z",
    transform: "translate(3.8 6.612)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9958",
    "data-name": "Path 9958",
    d: "M4.1,27.1V22.4c.2-.3.4-.3.7-.3H37.3c1,0,1.1-.1,1.3-1.1a10.012,10.012,0,0,1,3.2-5.2,7.991,7.991,0,0,1,5-1.9H64.4a1.978,1.978,0,0,1,1.1.2,3.064,3.064,0,0,1,.4,1.7V19H47.1a4.178,4.178,0,0,0-4.2,3.5,3.4,3.4,0,0,0-.1,1c-.2,2.1-1.2,3.4-3.1,3.6a9.7,9.7,0,0,1-1.7.1H4.9C4.8,27.1,4.5,27.1,4.1,27.1Z",
    fill: "#d3d1d2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9959",
    "data-name": "Path 9959",
    d: "M66.2,65.1H3.9A3.8,3.8,0,0,1,.1,61.3V31a4.8,4.8,0,0,1,4.8-4.8H39.7l3.1-5.8a2.883,2.883,0,0,1,2.6-1.6H67a2.946,2.946,0,0,1,3,3V61.3A3.8,3.8,0,0,1,66.2,65.1Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9960",
    "data-name": "Path 9960",
    d: "M56.5,23.4H47.6a1.025,1.025,0,0,1,0-2H65.4a1.009,1.009,0,0,1,.9,1.1.977.977,0,0,1-.9,1h-.7C61.9,23.4,59.2,23.4,56.5,23.4Z",
    fill: "#3a484a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9961",
    "data-name": "Path 9961",
    d: "M35,46.3a6.069,6.069,0,0,1-4.2-1.7c-.6-.6-.7-1.2-.2-1.7a1.123,1.123,0,0,1,1.6.1c1.8,1.6,3.7,1.6,5.6,0a1.123,1.123,0,0,1,1.6-.1,1.136,1.136,0,0,1-.2,1.6A5.261,5.261,0,0,1,35,46.3Z",
    fill: "#3a484a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9962",
    "data-name": "Path 9962",
    d: "M21.2,42.5v1.3c-.1.7-.5,1.1-1,1.1a1.09,1.09,0,0,1-1.1-1V41.2a.945.945,0,0,1,1-1,1.09,1.09,0,0,1,1.1,1v1.3Z",
    fill: "#3a484a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9963",
    "data-name": "Path 9963",
    d: "M50.9,42.5v1.4c-.1.6-.4,1-1.1.9a.923.923,0,0,1-1-.9,14.054,14.054,0,0,1,0-2.9c0-.6.4-.9,1-.9a1.009,1.009,0,0,1,1.1.9A7.5,7.5,0,0,1,50.9,42.5Z",
    fill: "#3a484a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMnAdmGrey);
export default __webpack_public_path__ + "static/media/ic_mn_adm_grey.027b46f7c2d443bd4b44ae8240f6260c.svg";
export { ForwardRef as ReactComponent };